import React, { useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import RateSlider from "../components/common/RateSlider";
import EditProfile from "../components/layouts/userPanel/EditProfile";
import MyCounter from "../components/layouts/userPanel/MyCounter";
import UserComments from "../components/layouts/userPanel/UserComments";
import UserNotification from "../components/layouts/userPanel/UserNotification";
import UserReserve from "../components/layouts/userPanel/UserReserve";
import UserStatics from "../components/layouts/userPanel/UserStatics";
import Wallete from "../components/layouts/userPanel/Wallete";
import WishList from "../components/layouts/userPanel/WishList";
import { CreatePlaceProvider } from "../context/CreatePlaceContext";
import { UserContextProvider } from '../context/UserContext';
import AdminLayout from '../layouts/AdminLayout';
import Blog from "../layouts/Blog";
import BlogDetail from "../layouts/BlogDetail";
import Categories from "../layouts/Categories";
import Create from "../layouts/Create";
import Home from "../layouts/Home";
import HomeLayout from "../layouts/HomeLayout";
import NotFoundPage from '../layouts/NotFoundPage';
import PlaceDetail from "../layouts/PlaceDetail";
import Register from "../layouts/Register";
import UserPanelLayout from "../layouts/UserPanelLayout"
import AdminResidences from "../components/layouts/admin/AdminResidences/AdminResidences";
import AdminCategories from "../components/layouts/admin/AdminCategories/AdminCategories";
import AdminNotification from "../components/layouts/admin/AdminNotification/AdminNotification";
import AdminFastSearch from "../components/layouts/admin/AdminFestSearch/AdminFastSearch";
import AdminUsers from "../components/layouts/admin/AdminUsers/AdminUsers";
import AddUsers from "../components/layouts/admin/AdminUsers/AddUsers";
import AdminJudje from "../components/layouts/admin/AdminJudje/AdminJudje";
// import AdminFeedbacks from '../components/layouts/admin/AdminFeddbacks/AdminFeedbacks';
// import AdminBlog from '../components/layouts/admin/AdminBlog/AdminBlog';
const UnAuthenticated = () => {
 
  return (
    <div>
     
          <Routes>
          <Route element={<HomeLayout />}>
            <Route path="/"  element={<Home />} />
            <Route path="/categories"  element={<Categories />} />
            <Route path="/place/:code/:slug"  element={<PlaceDetail />} />
            <Route path="/blog"  element={<Blog />} />
            <Route path="/blog/:id/:slug"  element={<BlogDetail />} />
          <Route path='*' element={<NotFoundPage />} />

          </Route>
          <Route path="/register"  element={<Register />} />
          <Route path="/create"  element={<Register />} />
          <Route path="/user/"  element={<Register />} />
          <Route path="/admin/"  element={<Register />} />

       
        </Routes>
    </div>
  )
}

export default UnAuthenticated